import { Bookmark, BookOpen, ChevronRight, Globe2, Menu, Scale, Search, X } from "lucide-react";
import { useState } from "react";
import { Link, NavLink, Outlet, useLocation } from "react-router-dom";
import { useSaved } from "../saved";

const links = [
  { to: "/countries", label: "Страны" }, { to: "/map", label: "Карта" }, { to: "/compare", label: "Сравнение" }, { to: "/knowledge", label: "База знаний" }
];

export function Logo() {
  return <Link to="/" className="logo" aria-label="Neturism — на главную"><span className="logo-mark"><i /><i /></span><strong>Neturism</strong></Link>;
}

export function Layout() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const saved = useSaved();
  const close = () => setOpen(false);
  return <div className="app-shell">
    <a className="skip-link" href="#content">Перейти к содержанию</a>
    <header className="site-header">
      <div className="container nav-wrap">
        <Logo />
        <nav id="mobile-nav" className={open ? "main-nav is-open" : "main-nav"} aria-label="Основная навигация">
          {links.map((item) => <NavLink key={item.to} to={item.to} onClick={close} className={({ isActive }) => isActive ? "active" : ""}>{item.label}</NavLink>)}
          <NavLink to="/saved" onClick={close} className={({ isActive }) => isActive ? "saved-link active" : "saved-link"}><Bookmark size={17} /> Сохранённое{saved.slugs.length ? <span>{saved.slugs.length}</span> : null}</NavLink>
        </nav>
        <div className="nav-actions">
          <Link className="icon-button search-button" to="/countries" aria-label="Поиск стран"><Search size={20} /></Link>
          <Link className="button button-primary nav-cta" to="/compare">Сравнить страны <ChevronRight size={18} /></Link>
          <button className="icon-button menu-button" onClick={() => setOpen((value) => !value)} aria-expanded={open} aria-controls="mobile-nav" aria-label={open ? "Закрыть меню" : "Открыть меню"}>{open ? <X /> : <Menu />}</button>
        </div>
      </div>
    </header>
    <main id="content" key={location.pathname}><Outlet /></main>
    <footer className="site-footer"><div className="container footer-grid">
      <div><Logo /><p>Спокойно и честно о странах, данных и основаниях для переезда.</p></div>
      <div><h3>Исследовать</h3><Link to="/countries"><Globe2 size={16} /> Каталог стран</Link><Link to="/compare"><Scale size={16} /> Сравнение</Link><Link to="/knowledge"><BookOpen size={16} /> База знаний</Link></div>
      <div><h3>О данных</h3><Link to="/sources">Источники</Link><Link to="/methodology">Методология</Link><a href="https://unsplash.com/@nickkarvounis" target="_blank" rel="noreferrer">Фото: Nick Karvounis / Unsplash</a><a href="https://unsplash.com/license" target="_blank" rel="noreferrer">Лицензия Unsplash</a><p className="fine-print">Информация не является юридической консультацией.</p></div>
    </div></footer>
  </div>;
}
